import { render, staticRenderFns } from "./DeptSettingTree.vue?vue&type=template&id=65b5c7bf&scoped=true&"
import script from "./DeptSettingTree.vue?vue&type=script&lang=js&"
export * from "./DeptSettingTree.vue?vue&type=script&lang=js&"
import style0 from "./DeptSettingTree.vue?vue&type=style&index=0&id=65b5c7bf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b5c7bf",
  null
  
)

export default component.exports